


















































import Vue from "vue";

import graphqlQuery from "@/service/Api";
import { getIsoOffsetDate } from "@/helpers";
import { chartOptions } from "./config";
import { mapState } from "vuex";
export default Vue.extend({
  components: {
    DashboardHeader: () =>
      import("@/views/main/dashboard/components/DashboardHeader.vue"),
    DashboardLineChart: () =>
      import("@/views/main/dashboard/components/DashboardLineChart.vue"),
    DashboardPenilaianSurvey: () =>
      import("@/views/main/dashboard/components/DashboardPenilaianSurvey.vue"),
    DashboardUpbjjTerbaik: () =>
      import("@/views/main/dashboard/components/DashboardUpbjjTerbaik.vue"),
  },
  data() {
    return {
      dateRange: { start: "", end: null as string | null },
      isLoaded: false,
      ratingCount: [],
      visitCount: [],
      kritikSaranCount: { yesterdayTotal: 0, todayTotal: 0 },
      isModalHistoryUrl: false,
      isLoading: {
        bestUnit: true,
        penilaianSurvey: true,
        kurvaPenilaian: true,
        visitCount: true,
        kritikSaran: true,
      },
      isError: {
        bestUnit: false,
        penilaianSurvey: false,
        kurvaPenilaian: false,
        visitCount: false,
        kritikSaran: false,
      },
      isModalGenerateSurvey: false,
      theadHistoryUrl: [
        {
          title: "URL",
          id: "url",
        },
        {
          title: "Tanggal",
          id: "tanggal",
        },
      ],
      theadModalDaftarSaran: [
        {
          title: "Saran dan Masukan",
          id: "answer",
        },
        {
          title: "Front Desk",
          id: "user.fullname",
        },
        {
          title: "Tanggal",
          id: "date",
        },
      ],
      listsModalDaftarSaran: [],
      penilaianSurvey: [],
      penilaianSurveyRange: [],
      upbjjTerbaik: [],

      series: [
        {
          name: "Rating",
          data: [{ x: "", y: 0 }],
        },
      ],
      chartOptions: chartOptions,
    };
  },
  computed: {
    ...mapState("authService", ["userProfile"]),
  },
  methods: {
    graphqlQuery,

    async calculateGlobalQuestionnare({
      isAccumulative = false,
      from = "",
      to = "",
      range = false,
    } = {}) {
      const query = `
        query($id: String!, $isAccumulative: Boolean!${
          range ? ", $range: DateRange!" : ""
        }) {
          calculateUnitQuestionnare(
            id: $id
            isAccumulative: $isAccumulative
            ${range ? "range: $range" : ""}
          ) {
            data {
              count
              surveyQuestion
              averageAnswer
              date
            }
          }
        }
      `;

      const variables = {
        id: this.userProfile.unit._id,
        isAccumulative: isAccumulative,
        range: range
          ? {
              from: from,
              to: to,
            }
          : undefined,
      };

      const result = await this.graphqlQuery({ query, variables }).then(
        (res) => res.data.calculateUnitQuestionnare.data,
      );
      return result;
    },

    // getVisistedPeople() {},
    async getEssayAnswers() {
      const query = `
        query {
          getEssayAnswersByUnit(id:"${this.userProfile.unit._id}",limit:99999999) {
            answer
            date
            unit {
              name
            }

            user {
             fullname
           }
          }
        }
      `;
      await this.graphqlQuery({ query }).then((res) => {
        this.listsModalDaftarSaran = res.data.getEssayAnswersByUnit;
      });
    },
    async changeRange() {
      if (this.dateRange.end) {
        this.isLoading.kurvaPenilaian = true;
        this.penilaianSurveyRange = await this.calculateGlobalQuestionnare({
          range: true,
          isAccumulative: true,
          from: this.dateRange.start,
          to: this.dateRange.end,
        })
          .then((res) => {
            this.isError.kurvaPenilaian = false;
            return res;
          })
          .catch((err) => {
            this.isError.kurvaPenilaian = true;
            return err;
          });
        this.isLoading.kurvaPenilaian = false;
        this.series = [
          {
            name: "Rating",
            data: this.penilaianSurveyRange.map((data: any) => {
              return { x: data.date, y: data.averageAnswer };
            }),
          },
        ];
      }
    },
    async getvisitCount() {
      this.isLoading.visitCount = true;
      const result = await this.calculateGlobalQuestionnare({
        range: true,
        isAccumulative: true,
        from: getIsoOffsetDate({ offset: -1 }),
        to: getIsoOffsetDate({ offset: 0 }),
      })
        .then((res) => {
          this.isError.visitCount = false;
          return res;
        })
        .catch(() => {
          this.isError.visitCount = true;
          return [];
        });
      this.visitCount = result.map((data: { count: number }) => data.count);
      this.ratingCount = result.map((data: { averageAnswer: number }) =>
        parseFloat(data.averageAnswer.toFixed(1)),
      );
      this.isLoading.visitCount = false;
    },
    async getPenilaianSurvey() {
      this.isLoading.penilaianSurvey = true;
      this.penilaianSurvey = await this.calculateGlobalQuestionnare()
        .then((res) => {
          this.isError.penilaianSurvey = false;
          return res;
        })
        .catch((err) => {
          this.isError.penilaianSurvey = true;
          return err;
        });
      this.isLoading.penilaianSurvey = false;
    },
    async getKritikSaran() {
      this.isLoading.kritikSaran = true;
      const query = `
        query {
          countEssayUnit {
            total
            yesterdayTotal
            todayTotal
          }
        }
      `;

      await this.graphqlQuery({ query })
        .then((res) => {
          this.kritikSaranCount = res.data.countEssayUnit;
          this.isError.kritikSaran = false;
        })
        .catch((err) => {
          this.isError.kritikSaran = true;
          return err;
        });
      this.isLoading.kritikSaran = false;
    },
  },

  async mounted() {
    this.dateRange.start = getIsoOffsetDate({ offset: -30 });
    this.dateRange.end = getIsoOffsetDate({ offset: 0 });
    await Promise.all([
      this.getPenilaianSurvey(),
      this.getvisitCount(),
      this.changeRange(),
      this.getKritikSaran(),
    ]);
    this.isLoaded = true;
  },
});
